export default __webpack_public_path__ + "static/media/Photo 8 - MR - verrière au plafond.8fcc6790.jpg";